import { TFunction } from 'i18next'

const useEmailValidation = (
  emails: string,
  t: TFunction<'translation', undefined>,
): string | true => {
  const trimmedInput = emails.trim()
  if (trimmedInput.length === 0) {
    return true
  }

  const emailArray = trimmedInput
    .split(/[;,]/)
    .map((email) => email.trim())
    .filter((email) => email.length > 0)

  // regex to allow multi-part domains
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

  // Validate each email
  if (
    emailArray.some((email) => {
      if (!emailRegex.test(email)) {
        return true
      }

      // Check repeated last two domain parts
      const domain = email.split('@')[1]
      const parts = domain.split('.')
      if (parts.length >= 2) {
        const last = parts[parts.length - 1].toLowerCase()
        const secondLast = parts[parts.length - 2].toLowerCase()
        if (last === secondLast) {
          return true
        }
      }

      return false
    })
  ) {
    return t('Invoicing.ValidEmailAddress')
  }

  if (trimmedInput.split(/[;,]/).map((email) => email.trim()).length > 1) {
    return t('Invoicing.OnlyOneEmailAllowed')
  }

  const raw = process.env.REACT_APP_BLOCKED_RSMEMAIL_DOMAINS
  let blockedDomainNames: string[] = []

  if (raw) {
    try {
      const unescaped = raw.replace(/\\"/g, '"')
      blockedDomainNames = JSON.parse(unescaped)
    } catch (err) {
      console.error('Failed to parse domain list:', err)
    }
  }

  const hasBlockedDomain = Array.isArray(blockedDomainNames)
    ? emailArray.some((email) =>
        blockedDomainNames.some((domain) => email.endsWith(domain)),
      )
    : false

  if (hasBlockedDomain) {
    return t('Invoicing.BlockedEmailDomains')
  }

  return true
}

export default useEmailValidation
